/* ready */
$(function() {
  'use strict';

  $('.p-faq__list dt').click(function() {
    $(this).toggleClass('is-open').next().stop().slideToggle();
  });
});